var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartialWithdrawSucc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.827 5.227H5v-2.3L.333 6.377 5 9.824v-2.3h3.827a2.297 2.297 0 010 4.594H2.43v2.297h6.398a4.597 4.597 0 004.592-4.596 4.592 4.592 0 00-4.592-4.592z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 14.959a4.375 4.375 0 100-8.75 4.375 4.375 0 000 8.75z",
    fill: "#FA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.88 10.584a3.254 3.254 0 00-3.255-3.255v6.509a3.254 3.254 0 003.254-3.254z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/partial-withdraw-succ.97973320.svg";
export { SvgPartialWithdrawSucc as ReactComponent };